import * as React from "react";
import { DataService } from "../../services/DataService";
import { IsUserSinfra } from "../../lib/utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { useCurrentDepartmentHook } from "../SupplierBar/SupplierBar";

export interface IReportNoticeProps {
  hideKickbackMsg?: boolean;
  hideInvoiceMsg?: boolean;
  withLinks?: boolean;
  reportType?:number;
  periods?:string[] | string;
}
const normalizePeriodKey = (p: any): string => {
  if (!p) return "";
  if (p instanceof Date) return p.toISOString().slice(0, 7);

  const s = String(p).trim();
  return s.length >= 7 ? s.slice(0, 7) : s; // "yyyy-MM"
};

const monthIndex = (yyyyMM: string): number => {
  // yyyyMM = "2026-01"
  const y = Number(yyyyMM.slice(0, 4));
  const m = Number(yyyyMM.slice(5, 7));
  if (!Number.isFinite(y) || !Number.isFinite(m)) return Number.NaN;
  return y * 12 + (m - 1); // 0-baserad månad
};

const currentMonthKey = () => {
  const now = new Date();
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, "0");
  return `${y}-${m}`;
};

/**
 * Behåll bara perioder STRICTLY BEFORE current month.
 * (dvs tar bort current month + allt i framtiden)
 */
const filterOutCurrentAndFuture = (periods: any[]): string[] => {
  const curKey = currentMonthKey();
  const curIdx = monthIndex(curKey);

  return (periods ?? [])
    .map(normalizePeriodKey)
    .filter((k) => {
      const idx = monthIndex(k);
      return k && Number.isFinite(idx) && idx < curIdx;
    });
};

/*export default*/ function ReportNotice(props : IReportNoticeProps) {
  
  const [kickbackText, setKickbackText] = React.useState("");
  const [invoiceText, setInvoiceText] = React.useState("");
  const { t } = useTranslation(); 
  // const {currentDepartment,getMissedPeriodsAsString} = useCurrentDepartmentHook();
  const { currentDepartment, departmentLoaded, getMissedPeriodsText,reportedPeriods } = useCurrentDepartmentHook();
const dep = currentDepartment(); // Department | null | undefined
const depId = dep && dep !== null ? dep.id : null;
const reportedCount = Object.keys(reportedPeriods).length;
React.useEffect(() => {
  async function start() {
    if (!departmentLoaded) return;     // <-- stoppar läckan/racet

    if (dep) await checkDepartmentPeriods();  // dep är Department
    else await checkRegularPeriods();         // dep är null => riktig no-dept user
  }
  start();
}, [departmentLoaded, depId,reportedCount]);
  // const checkDepartmentPeriods = async () => {
  
  //   if (IsUserSinfra()) return;
  //  const {kickbackText,statisticText} = await getMissedPeriodsAsString();
  //   if(kickbackText.length > 0){
  //     setKickbackText(
  //       t("reportNotice.kickback.description").replace("{months}",kickbackText))
  //   }
  //   if(statisticText.length > 0){
  //     setInvoiceText(t("reportNotice.invoice.description").replace("{months}",statisticText))
  //   }
  // }
const checkDepartmentPeriods = async () => {
  if (IsUserSinfra()) return;

  const { kickbackText, statisticText } = getMissedPeriodsText();
console.log(kickbackText,'!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!')
  if (kickbackText.length > 0) {
    setKickbackText(
      t("reportNotice.kickback.description").replace("{months}", kickbackText)
    );
  } else {
    setKickbackText("");
  }

  if (statisticText.length > 0) {
    setInvoiceText(
      t("reportNotice.invoice.description").replace("{months}", statisticText)
    );
  } else {
    setInvoiceText("");
  }
};

  // const checkRegularPeriods = async () => {
  //   if (IsUserSinfra()) return;
  //   const [missedKickbackReports, missedInvoiceReport] = await Promise.all([
  //     DataService.Kickback.GetMissedPeriods(),
  //     DataService.Invoices.GetMissedPeriods(),
  //   ]);
  //       if (missedKickbackReports.length > 0) {
  //       const months = missedKickbackReports
  //         .map((p) => new Date(p).toLocaleDateString("sv-se", { month: "long" }))
  //         .join(",");
  //       setKickbackText(
  //         t("reportNotice.kickback.description").replace("{months}", months)
  //       );
  //     }
  //     if (missedInvoiceReport.length > 0) {
  //       const months = missedInvoiceReport
  //         .map((p) => new Date(p).toLocaleDateString("sv-se", { month: "long" }))
  //         .join(",");
  //       setInvoiceText(
  //         t("reportNotice.invoice.description").replace("{months}", months)
  //       );
  //     }    
  // };
// const checkRegularPeriods = async () => {
//   if (IsUserSinfra()) return;

//   let [missedKickbackReports, missedInvoiceReport] = await Promise.all([
//     DataService.Kickback.GetMissedPeriods(),
//     DataService.Invoices.GetMissedPeriods(),
//   ]);

//   missedKickbackReports = filterOutCurrentAndFuture(missedKickbackReports);
//   missedInvoiceReport = filterOutCurrentAndFuture(missedInvoiceReport);
//  console.log(missedKickbackReports,missedInvoiceReport)
//   if (missedKickbackReports.length > 0) {
//     const months = missedKickbackReports
//       .map((p) => new Date(p).toLocaleDateString("sv-se", { month: "long" }))
//       .join(",");
//     setKickbackText(
//       t("reportNotice.kickback.description").replace("{months}", months)
//     );
//   } else {
//     setKickbackText("");
//   }

//   if (missedInvoiceReport.length > 0) {
//     const months = missedInvoiceReport
//       .map((p) => new Date(p).toLocaleDateString("sv-se", { month: "long" }))
//       .join(",");
//     setInvoiceText(
//       t("reportNotice.invoice.description").replace("{months}", months)
//     );
//   } else {
//     setInvoiceText("");
//   }
// };
const checkRegularPeriods = async () => {
  if (IsUserSinfra()) return;
console.log("[DBG] checkRegularPeriods: calling GetMissedPeriods()");

  let [missedKickbackReports, missedInvoiceReport] = await Promise.all([
    DataService.Kickback.GetMissedPeriods(),
    DataService.Invoices.GetMissedPeriods(),
  ]);

  // HARD FAILSAFE: ta bort current + framtid
  const kickback = filterOutCurrentAndFuture(missedKickbackReports as any[]);
  const invoiceCandidates = filterOutCurrentAndFuture(missedInvoiceReport as any[]);
  const invoice = (
    await Promise.all(
      invoiceCandidates.map(async (period) => {
        const canNullReport =
          await DataService.NullReports.CanNullreportOnSelectedPeriod(period);

        return canNullReport ? period : null;
      })
    )
  ).filter((period): period is string => period !== null);

  console.log("raw:", missedKickbackReports, missedInvoiceReport);
  console.log("filtered (past only):", kickback, invoice, "current:", currentMonthKey());

  if (kickback.length > 0) {
    const months = kickback
      .map((p) => new Date(`${p}-01T00:00:00Z`).toLocaleDateString("sv-se", { month: "long" }))
      .join(",");
    setKickbackText(t("reportNotice.kickback.description").replace("{months}", months));
  } else {
    setKickbackText("");
  }

  if (invoice.length > 0) {
    const months = invoice
      .map((p) => new Date(`${p}-01T00:00:00Z`).toLocaleDateString("sv-se", { month: "long" }))
      .join(",");
    setInvoiceText(t("reportNotice.invoice.description").replace("{months}", months));
  } else {
    setInvoiceText("");
  }
};

  const renderNotice = (text: string, url: string) => {
    return (
      <div className="notice">
        <FontAwesomeIcon icon={faWarning} />
        <div
          className={props.withLinks ? "notice-clickable" : ""}
          onClick={() => {
            if (props.withLinks) window.location.href = url;
          }}
        >
          {text}
        </div>
      </div>
    );
  };
console.log(invoiceText,kickbackText)
  return (
    <>    
      {(kickbackText.length > 0 && !props.hideKickbackMsg || invoiceText.length > 0 && !props.hideInvoiceMsg) && (
        <div className="report-notice">
          {kickbackText.length > 0 &&
            !props.hideKickbackMsg &&
            renderNotice(kickbackText, "/report")}
          {invoiceText.length > 0 &&
            !props.hideInvoiceMsg &&
            renderNotice(invoiceText, "/report")}
        </div>
      )}
    </>
  );
}
export default React.memo(ReportNotice)
